import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import NewMessageSound from "../../../assets/sound/new-message.mp3";
import { endOfTitle } from "../../../constants/constants";
import { Conversations } from "../components/Conversations";
import { Messages } from "../components/Messages";
import { MessagesProvider } from "../MessagesContext";
import { IMessagesPageConfig } from "../types";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
    columnGap: 24,
  },
}));

export const MessageWidgetPage = ({
  school,
  serviceProvider,
  teacher,
  student,
  recipientId,
  userRole,
}: IMessagesPageConfig) => {
  const classes = useStyles();
  const audioPlayer = useRef(null);

  return (
    <>
      <Helmet>
        <title>Messages{endOfTitle}</title>
      </Helmet>
      <audio ref={audioPlayer} src={NewMessageSound} />
      <MessagesProvider
        school={school}
        serviceProvider={serviceProvider}
        teacher={teacher}
        student={student}
        recipientId={recipientId}
        userRole={userRole}
        audioPlayer={audioPlayer}
      >
        <Container maxWidth="lg" className={classes.root}>
          <Conversations />
          <Messages />
        </Container>
      </MessagesProvider>
    </>
  );
};
